import List from "../../../../__snowpack__/pkg/@mui/material/List.js";
import styled from "styled-components";
export const RadioListContainer = styled(List).withConfig({
  displayName: "radio-liststyles__RadioListContainer",
  componentId: "sc-jcpy1d-0"
})(["height:27rem;max-height:27rem;overflow:auto;background-color:white;box-shadow:0 1px 5px 0 #0000001f;"]);
